import React from "react";
import { Heading } from "rebass";

type Props = {
  title: string
};

const Header = (props: Props) => (
  <Heading center color="support2" className="font-light" {...props}>
    {props.title}
  </Heading>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx